<template>
  <div>
    <v-layout row wrap>
      <v-flex pb-1 xs12 sm12 md12>
        <v-text-field :label="etiket" @blur="codeControl()"
          :tabindex="tabdeger" mask="NNNNN" v-model="val" hide-details=""></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 md12>
        <span class="body-1 font-weight-bold grey--text mb-2">
          {{text1}} </span>
      </v-flex>
    </v-layout>
    <v-card>

    </v-card>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    props: ["value", "tabdeger", "etiket"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    beforeMount: beforeMount,
    methods: {
      codeControl: codeControl
    },
    data() {
      return {
        kodmesajı: null,
        progress: false,
        items: [],
        aranacakkelime: null,
        secilenkayit: null,
        listedialog: false,
        text1: this.$t('Unidentified-Person'),
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {

    },
  }

  function beforeMount() {

    this.codeControl();
  }

  function codeControl() {
    if (this.val != null && this.val != '') {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params = {
        SirketKodu: credentials.SirketKodu,
        Kodu: escape(this.val)
      }

      this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanLoad', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        if (response.body.Adi != null || response.body.Soyadi != null) {
          this.text1 = response.body.Adi + ' '+ response.body.Soyadi
        } else {
          this.text1 = this.$t('Unidentified-Person-v2')
        }
      }, (response) => {
        if (response.status === 0) {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })

    } else {
      this.kodmesajı = null
    }
  }
</script>